import colors from "./colors";
const {
    black,
    blue,
    darkGrey,
    darkGreyText,
    lightGrey,
    lightGreen,
    emerald,
    green,
    red,
    white,
    yellow,
} = colors;

const theme = {
    typography: {
        allVariants: {
            color: black,
        },
        body1: {
            color: black,
        },
        body2: {
            color: black,
        },
        body1: {
            color: black,
        },
        body2: {
            color: black,
        },
    },
    palette: {
        type: "basic",
        org: "Checkventory",
        primary: {
            main: emerald,
        },
        loginScreen: {
            loginContainer: {
                background: white,
            },
            formContainer: {
                background: white,
            },
        },
        menuContainer: {
            background: emerald,
            color: white,
        },
        assetListHeading: {
            default: lightGreen,
            net: green,
        },
        background: {
            darkBackground: black,
            mediumBackground: lightGrey,
            lightBackground: white,
        },
        border: {
            primary: emerald,
            darkBorder: darkGrey,
            mediumBorder: "",
            lightBorder: lightGrey,
        },
        tabButtons: {
            active: emerald,
            activeText: white,
            default: lightGrey,
            defaultText: black,
        },
        text: {
            primary: emerald,
            secondary: black,
            darkText: darkGreyText,
            lightText: lightGrey,
            contrastText: white,
        },
        iconsColor: {
            primary: emerald,
            secondary: darkGrey,
        },
        iconsColor: {
            primary: emerald,
            secondary: darkGrey,
        },
        success: {
            main: emerald,
        },
        info: {
            main: blue,
        },
        warning: {
            main: yellow,
        },
        error: {
            main: red,
        },
    },
    props: {
        MuiTooltip: {
            arrow: true,
        },
        MuiChip: {
            color: "red",
        },
        MuiChip: {
            color: "red",
        },
        MuiButton: {
            size: "small",
        },
        MuiButtonGroup: {
            size: "small",
        },
        MuiCheckbox: {
            size: "small",
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: emerald,
                    minWidth: "36px",
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: emerald,
                    minWidth: "36px",
                },
            },
        },
        MuiFab: {
            size: "small",
        },
        MuiFormControl: {
            margin: "dense",
            size: "small",
        },
        MuiFormHelperText: {
            margin: "dense",
        },
        MuiIconButton: {
            size: "small",
        },
        MuiInputBase: {
            margin: "dense",
        },
        MuiInputLabel: {
            margin: "dense",
        },
        MuiRadio: {
            size: "small",
        },
        MuiSwitch: {
            size: "small",
        },
        MuiTextField: {
            margin: "dense",
            size: "small",
        },
        MuiList: {
            dense: true,
        },
        MuiMenuItem: {
            dense: true,
        },
        MuiTable: {
            size: "small",
        },
    },
    components: {
        MuiInputBase: {
            styleOverrides: {
                input: {
                    color: "#272727",
                },
            },
        },
    },
};

export default theme;
